import { render, staticRenderFns } from "./ot-date-time-field-wrapper.vue?vue&type=template&id=081445f5&scoped=true&"
import script from "./ot-date-time-field-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-date-time-field-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-date-time-field-wrapper.vue?vue&type=style&index=0&id=081445f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081445f5",
  null
  
)

export default component.exports